import React, { DetailedHTMLProps, TextareaHTMLAttributes, useEffect, useRef } from 'react';

interface Props extends DetailedHTMLProps<
  TextareaHTMLAttributes<HTMLTextAreaElement>,
  HTMLTextAreaElement
> {
  containerClasses?: string;
  focusOnLoad?: boolean;
  id: string;
  label?: string;
}

export const TextArea = ({ className, containerClasses, focusOnLoad = true, id, label, ...rest }: Props): JSX.Element => {
  const ref = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (focusOnLoad) {
      ref.current?.focus();
    }
  }, []);

  return (
    <div className={`${containerClasses ?? ''} relative`}>
      <textarea
        id={id}
        className={`${className ?? ''} peer w-full mt-5 p-1 px-0.5 border-0 border-b-2 border-neutral-200 focus:ring-0 focus:border-sapphire placeholder-transparent`}
        placeholder={label}
        ref={ref}
        {...rest}
      />
      {label && (
        <label
          className='absolute left-0.5 top-0 peer-focus:top-0 peer-placeholder-shown:top-6 text-neutral-700 peer-focus:text-sapphire peer-placeholder-shown:text-neutral-400 text-sm peer-focus:text-sm peer-placeholder-shown:text-base transition-all pointer-events-none'
          htmlFor={id}
        >
          {label}
        </label>
      )}
    </div>
  );
};
